<template>
  <!-- <v-card class="rigt_navbar" style="padding-left:0px"> -->
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>

    <div><HeaderComponent headerTitle="Real Time GRN" /></div>
    <v-card-title class="d-flex align-center">
      <a
        style="display: none"
        id="grn_report"
        small
        tile
        color="#F3F3F3"
        href=""
        target="_blank"
        download
      >
      </a>
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        v-model="search"
        v-no-edge-space
        label="Search OBD"
        variant="outlined"
        color="primary"
        v-on:keyup.enter="searchItem()"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-card-actions>
        <v-layout align-center>
          <v-btn @click="downloadPDF()" variant="flat" class="ma-2 text-white" color="blue"
            >Download</v-btn
          >
        </v-layout>
      </v-card-actions>
    </v-card-title>

    <v-layout column>
        <v-data-table
          hover
          density="compact"
          :headers="headers"
          :items="table_data"
          :items-per-page="pageSize"
          class="elevation-1"
        >
          <template v-slot:item.obd_date="{ item }">
            {{ format_date(item.dispatch_date) }}
          </template>
          <template #bottom></template>
        </v-data-table>
    </v-layout>
    <div class="w-100 ">
      <v-row class="ml-2 pb-0">
        <v-col cols="3" sm="3" class="PaddingItemPerPage d-flex mt-3">
          <label class="" style="margin-top: -2px;">Rows Per Page</label>
          <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
          variant="outlined" style="width: 40px;margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
        </v-col>
        <span class="item-selected"> <span v-if="selected ? selected.length == 1 : ''">{{ selected ? selected.length : '' }} Item Selected</span> <span
            v-if="selected ? selected.length > 1 : ''">{{ selected ? selected.length : '' }} Items Selected</span> </span>
        <v-spacer></v-spacer>
        <span class="pt-3 mt-3 mr-5" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
          - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
        <v-col cols="2" sm="2" class="PaddingItemPerPage custom-column-ui">
          <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
            @update:modelValue="handlePageChange" circle></v-pagination>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import { mapState } from "vuex";
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      alert: false,
      alert_message: "",
      alert_type: "",
      search: "",
      headers: [
        { title: "Source Site", align: "start", key: "source_code" },
        { title: "RP Site", key: "destination_code" },
        { title: "OBD Number", key: "client_gatepass_number" },
        { title: "OBD Date", key: "obd_date" },
        { title: "Ageing", key: "ageing" },
        { title: "Total OBD Qty", key: "total_items" },
        { title: "GRN Completed Qty", key: "inwarded_quanity" },
        { title: "Pending Qty", key: "pending_quantity" },
        { title: "Status", key: "gp_status" },
      ],
      table_data: [],
      page: 1,
      totalPages: 1,
      totalCount : '',
      pageSize: 100,
      pageSizes: [100, 200, 500],
    };
  },
  computed: mapState(["currentUser", "signedIn"]),
  created() {
    this.getGrnData();
  },
  components: {
    editor: Editor,
    HeaderComponent,
  },
  methods: {
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },

    handlePageChange(value) {
      this.page = value;
      this.getGrnData();
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getGrnData();
    },

    searchItem() {
      this.loading = true;
      const params = this.getRequestParams(this.page, this.pageSize);

      if (this.search.length != 0) {
        this.$httpSecured
          .get("/api/v1/warehouse/wms/gate_passes/get_grn_data", {
            params: { page: 1, per_page: params["size"], search: this.search },
          })
          .then((response) => {
            if (response.data) {
              this.table_data = response.data.gate_passes;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.showAlert("error", "No Records Found for given value");
            }
          })
          .catch((error) =>
            this.showAlert("error", "Error in fetching Filter Record"),
          );
      } else {
        this.loading = false;
        this.getGrnData();
      }
    },

    downloadPDF() {
      this.$toast.success("Report Will be autodownloaded please wait");
      this.$httpSecured
        .get("/api/v1/warehouse/wms/gate_passes/export_pending_grn_inventories")
        .then((response) => {
          this.file_url = response.data.url;
          document.getElementById("grn_report").href = response.data.url;
          document.getElementById("grn_report").click();
        })
        .catch((error) =>
          this.$toast.error("Error in fetching pending GRN inventories"),
        );
    },

    getGrnData() {
      this.loading = true;
      const params = this.getRequestParams(this.page, this.pageSize);

      this.loading = true;
      this.$httpSecured
        .get("/api/v1/warehouse/wms/gate_passes/get_grn_data", {
          params: { page: params["page"], per_page: params["size"] },
        })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.gate_passes;
            this.loading = false;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },

    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },

    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY");
      }
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text ? text.length : length < 0) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
};
</script>
<style scoped>
.theme--light.v-icon {
  color: #1867c0 !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 14px !important;
}
/* .v-card {
  max-width: 97% !important;
} */

.v-card-100 {
  max-width: 100% !important;
}
.inc-title {
  color: #172b4d;
  font-size: 20px;
}
.insurance-submission-table {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
</style>
